import React from "react";
import { Translate } from "react-redux-i18n";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaComments,
  FaWhatsapp,
} from "react-icons/fa";

function TransactionSellerContact({ contact }) {
  if (!contact) return null;

  const rows = [];

  if (contact.Email && contact.EmailAddress) {
    rows.push(
      <li key="email" className="transaction-seller-contact__row">
        <FaEnvelope />
        <a href={`mailto:${contact.EmailAddress}`}>{contact.EmailAddress}</a>
      </li>
    );
  }

  if (contact.Phone && contact.PhoneNumber) {
    rows.push(
      <li key="phone" className="transaction-seller-contact__row">
        <FaPhoneAlt />
        <span>
          {contact.PhoneNumber}
          {contact.Whatsapp && (
            <span className="transaction-seller-contact__wa">
              <FaWhatsapp /> WhatsApp
            </span>
          )}
        </span>
      </li>
    );
  }

  if (contact.Chat) {
    rows.push(
      <li key="chat" className="transaction-seller-contact__row">
        <FaComments />
        <span>
          <Translate value="contact_method_chat" />
        </span>
      </li>
    );
  }

  if (rows.length === 0) return null;

  return (
    <div className="transaction-seller-contact">
      <span className="transaction-seller-contact__label">
        <Translate value="transaction_seller_contact" />
      </span>
      <ul className="transaction-seller-contact__list">{rows}</ul>
    </div>
  );
}

export default TransactionSellerContact;
